import React, {useEffect, useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import Navbar from './Navbar';
//import { WhatsappShareButton, WhatsappIcon, FacebookShareButton, FacebookIcon, EmailShareButton, EmailIcon } from "react-share";
const Header = (props) => {
	const [enableMobileMenu] = useState(false);
	var [state, setState] = useState(false);
	var [flagWidth] = useState(true);
	
	var location = useLocation(); 
	//const shareUrl = window.location.href;
	
	useEffect((props) => {	
		const handleScroll = () => {
					const offset = window.scrollY;				
					const stickyheader = document.querySelector('.sticky-header');
					
					if (!stickyheader) return null;				
						if (offset >= 300) {
							stickyheader.classList.add('is-fixed');
							stickyheader.classList.add('color-fill');
							setState(true);	
						} else {
							stickyheader.classList.remove('is-fixed');
							stickyheader.classList.remove('color-fill');
							setState(false);
						}
					}
					
					window.addEventListener('scroll', handleScroll);
					
					
	}, [location]);	
  return (
  <>
   <header className={`site-header  ${props.headerStyle} ${enableMobileMenu ? " active " : ""} ${state ? " dark-menu " : ""} mobile-sider-drawer-menu  ${flagWidth ? " nav-boxed" : " nav-wide"}`} >
		<div className={`top-bar ${props.siteBackground}`}>
			<div className="container">
				<div className="wt-topbar-right">
					<ul className="list-unstyled e-p-bx">
						<li><i className="fa fa-envelope"></i>{process.env.REACT_APP_EMAIL_ADDRESS}</li>
						<li><i className="fa fa-phone"></i>{process.env.REACT_APP_SITE_CONTACT_NO}</li>
					</ul>
					<ul className="social-bx list-inline">
						<li><Link to={`https://www.facebook.com/${process.env.REACT_APP_FACEBOOK_USERNAME}`} className="fa fa-facebook"></Link></li>
						<li><Link to={`https://twitter.com/${process.env.REACT_APP_TWITTER_USERNAME}`} className="fa fa-twitter"></Link></li>
						<li><Link to={`https://in.linkedin.com/${process.env.REACT_APP_LINKEDIN_USERNAME}`} className="fa fa-linkedin"></Link></li>						
						<li><Link to={`https://www.youtube.com/${process.env.REACT_APP_YOUTUBE_USERNAME}`} className="fa fa-youtube"></Link></li>
						<li><Link to={`https://www.instagram.com/${process.env.REACT_APP_INSTAGRAM_USERNAME}`} className="fa fa-instagram"></Link></li>
					</ul>
					{/* <!--
					<ul className="social-bx list-inline">
						<li>
							<Link to="#" className=""> 
								<FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
									<FacebookIcon size={16} round />
								</FacebookShareButton>
							</Link>
						</li>										
						<li><Link to="#" className="">
								 <WhatsappShareButton url={shareUrl} title={title} separator=":: " className="Demo__some-network__share-button">
									<WhatsappIcon size={16} round />
								</WhatsappShareButton>
							</Link>
						</li>
						<li><Link to="#" className="">
								<EmailShareButton url={shareUrl}  subject={title}  body="HPS"  className="Demo__some-network__share-button">
								  <EmailIcon size={16} round />
								</EmailShareButton>
							</Link>
						</li>
					</ul>
					--> */}
				</div>
			</div>
		</div>
	<div className="sticky-wrapper" style={ { height:`${ state?"61px":"" }` } }>	
      <div className="sticky-header main-bar-wraper">
		<div className={`main-bar ${props.mainBarBackground} ${props.headerButton}`}>
			<div className="container">
				<div className="logo-header">
						{/*<!--Logo-->*/}
						  <div className="logo" data-mobile-logo={logo} data-sticky-logo={logo}>
							  <Link to="/"><img src={logo} alt="logo"/></Link>
						  </div>
				</div>
				
				<div className="header-nav navbar-collapse collapse ">
				 
					{/*<!-- SITE Navigation -->*/}							
					 <div className="main-menu-desktop-mode">
						 	<Navbar/>
					 </div>
					  <div className="main-menu-mobile-mode" style={{height:'100%', width:'100%', position:'absolute', top:'0'}}>
 
					  </div>
				</div>
				
				
			</div>
          </div>
      </div>
	  
	  
	  
	 </div> 
	</header>  
	
</>
  );
};
Header.defaultProps = {
    siteBackground: "site-bg-primary",
	headerStyle: "header-style-1",
	mainBarBackground:"bg-white",
	headerButton:""
};
export default Header;
